/**
 * Paul — Daily Audit Admin Page
 *
 * Standalone page wrapping the AuditStatusBox for /admin/audit route.
 * When the Eddie Gantt Dashboard is ported to React, the AuditStatusBox
 * component should be embedded at the top of the Gantt view instead.
 */

import { AuditStatusBox } from './AuditStatusBox';

export function DailyAuditPage() {
  return (
    <div style={{ maxWidth: 900, margin: '0 auto' }}>
      <h2 style={{
        fontFamily: "'Instrument Serif', Georgia, serif",
        fontSize: 28,
        fontWeight: 400,
        color: '#18181B',
        marginBottom: 16,
      }}>
        Daily System Audit
      </h2>
      <p style={{
        fontFamily: "'DM Sans', sans-serif",
        fontSize: 14,
        color: '#71717A',
        marginBottom: 20,
      }}>
        Paul inspects the entire building daily. 4 of 6 dimensions active. Camera and Brain pending.
      </p>
      <AuditStatusBox />
    </div>
  );
}
